import store from '@/store/index.js';

/**
 * @param  {String|Array} value
 * @param  {Boolean} defaultPermission=false
 * @return {Boolean}
 */
export default function checkPermission(value, defaultPermission = false) {
  if (value && value instanceof Array && value.length > 0) {
    return value.includes(store.getters.role);
  } else if (value && typeof value === 'string') {
    return store.getters.role === value;
  }
  return defaultPermission;
}
